<template>
  <modal title="Your session is about to expire." v-if="showModal && !loggedOut">
    <div slot="body">
      <p>
        Time remaining:
        <countdown :time="sessionExpires" @countdownend="logout()">
          <template slot-scope="props">{{ props.seconds }} seconds.</template>
        </countdown>
      </p>
      <btn @click.prevent="extend()">Keep Working</btn>
    </div>
  </modal>
</template>

<script>

  import Modal from "@/components/Modal"
  import httpAdapter from "@/store/adapters/http"

  const SESSION_LENGTH = (120 * 60 * 1000)
  const SESSION_OFFSET = (60 * 1000)

  export default {
    name: 'SessionWarning',
    props: ['session'],
    components: { Modal },
    data () {
      return {
        sessionExpires: null,
        sessionTimer: null,
        showModal: false,
        loggedOut: false
      }
    },
    created () {
      httpAdapter.http.interceptors.response.use((response) => {
        if(_.get(response, "headers['ss-authenticated']")) {
          this.initTimer()
        }
        return response;
      }, (error) => {
        return Promise.reject(error);
      })
    },
    methods: {
      initTimer () {
        if(this.sessionTimer) {
          clearTimeout(this.sessionTimer)
        }
        this.sessionTimer = setTimeout(() => {
          this.sessionExpires = 59000
          this.showModal = true
        }, (SESSION_LENGTH - SESSION_OFFSET))
      },
      logout () {
        this.$router.push({name: "logout"})
        this.showModal = false
        this.loggedOut = true
      },
      extend () {
        this.$store.find('ping','auth')
        this.showModal = false
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

</style>



// WEBPACK FOOTER //
// src/components/SessionWarning/index.vue